import React, { useState } from 'react';
import { SearchMedicamentRecordPatientFormValues } from '../SearchMedicamentRecordPatientsDataFormScheme';
import useNotification from '../../../../Hooks/useNotification.hook';
import { useEffectAsync } from '../../../../helpers';
import apiClient from '../../../../Services/ApiClient';
import withLoading from '../../../../Libs/withLoading';
import { formatQueryString } from '../../../../Services/Api/FormatQueryString';
import Text from '../../../Base/Text/Text';

// @ts-ignore
import styles from './SearchMedicamentRecordList.module.scss';
import SearchMedicamentRecordListItem, {
	SearchMedicamentRecordListItemScheme,
} from './SearchMedicamentRecordListItem';

interface EReceptMedicamentsProps {
	filterData: SearchMedicamentRecordPatientFormValues;
	onError?: () => void;
	setLoading: (newState: boolean) => void;
	isLoading: boolean;
	onSUKLWrongCredentials: () => void;
}

const SearchMedicamentRecordList: React.FC<EReceptMedicamentsProps> = props => {
	const { filterData, onError, onSUKLWrongCredentials, setLoading, isLoading } =
		props;
	const { showNotificationAlert } = useNotification();
	const [data, setData] = useState<SearchMedicamentRecordListItemScheme[]>([]);

	// @ts-ignore
	useEffectAsync(async () => {
		if (filterData && Object.keys(filterData).length) {
			await loadData();
		}
	}, [filterData]);

	const prepareQueryParameters = ({
		firstName,
		lastName,
		dateOfBirth,
		months,
		useAddress,
		address,
		useDocument,
		identificationDocument,
	}: SearchMedicamentRecordPatientFormValues) => {
		const filterParams = {
			firstName,
			lastName,
			dateOfBirth,
			months: months?.value || months,
			atc: 5,
			...(useAddress && address),
			...(useDocument && {
				documentNumber: identificationDocument?.documentNumber,
				documentType: identificationDocument?.documentType.value,
			}),
			version: 2,
		};

		return formatQueryString(filterParams);
	};

	// @ts-ignore
	const loadData = async () => {
		setLoading(true);

		try {
			const query = prepareQueryParameters(filterData);
			const {
				data: { data },
			} = await apiClient.get('/erecept/lekovy-zaznam?' + query, {
				catchError: false,
			});
			if (data) {
				setData(data);
			}
		} catch (e: any) {
			if (e.response.data.displayableError) {
				showNotificationAlert({
					content: e.response.data.message,
				});
			}
			if (
				e.response.data.message ===
				'Chybné uživatelské jméno/heslo nebo zablokovaný/neaktivovaný účet na SÚKL!'
			) {
				onSUKLWrongCredentials();
			} else {
				onError?.();
			}
		} finally {
			setLoading(false);
		}
	};

	if (isLoading) {
		return <></>;
	}

	if (data?.length < 1) {
		return (
			<div className={styles.wrapper}>
				<div className={styles.list}>
					<div className={styles.noData}>
						<Text tx='component.eReceptMedicaments.noMedicaments' />
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.list}>
				{data.map((item, index) => {
					return (
						<React.Fragment key={index}>
							<SearchMedicamentRecordListItem item={item} />
						</React.Fragment>
					);
				})}
			</div>
		</div>
	);
};

export default withLoading(SearchMedicamentRecordList);
